/**
 * Portal visual preview cannot act as a guest (issue #370).
 *
 * The preview iframe authenticates with a portal preview JWT, which the guest API refuses on every
 * guest-identity write route (check-in, RSVP, guestbook, questions, votes) with
 * `403 { error: 'PREVIEW_READ_ONLY' }`. The UI disables those controls up front
 * (`useGallery().isPreview`) and uses this shared copy/detection if a write is still attempted.
 * Owner uploads from the preview are allowed (#281), so upload controls are not disabled.
 */

export const PREVIEW_READ_ONLY_CODE = 'PREVIEW_READ_ONLY';

export const PREVIEW_ONLY_MESSAGE = 'Preview only — guests can do this on the live gallery.';

/**
 * @param {unknown} error axios-style error from a guest write request
 * @returns {boolean} true when the API rejected the write because the session is a portal preview
 */
export function isPreviewReadOnlyError(error) {
  return (
    error?.response?.status === 403 &&
    error?.response?.data?.error === PREVIEW_READ_ONLY_CODE
  );
}
